import { useSelector } from 'react-redux'
import type { State, Profile } from 'types'

export const useUser = (userId: string): Profile => {
  return useSelector<State, Profile>(state => state.entities.users[String(userId)])
}
